import { initializeMultipayment } from '../../components/contents/Head/initializeMultipayment'
import { usePropertyProvider } from '../usePropertyProvider'

type GetTokenProps = {
  cardno: string
  expire: string
  holdername: string
  securitycode: string
}

export type TokenResultProps = {
  resultCode: '000' | number
  tokenObject: {
    isSecurityCodeSet: boolean | string
    maskedCardNo: string
    toBeExpiredAt: string
    token: string[]
  }
}

const TOKEN_NO = '1' // Number of tokens to be issued
const MULTIPAYMENT_NOT_LOADED_ERROR = 'GMO Multipayment has not loaded'

export const useGMOMultiPaymentApi = () => {
  const { gmoShopId } = usePropertyProvider()

  const onGetToken = ({
    cardno,
    expire,
    holdername,
    securitycode,
  }: GetTokenProps) =>
    new Promise<TokenResultProps>((resolve, reject) => {
      // Re-run init defensively: if the script's onload fired before
      // window.Multipayment was populated, PaymentHead's initialize call
      // no-ops and the client is left uninitialized. Initializing here
      // guarantees the GMO client is ready right before tokenization.
      initializeMultipayment(gmoShopId)

      if (!window.Multipayment) {
        reject(new Error(MULTIPAYMENT_NOT_LOADED_ERROR))
        return
      }

      window.Multipayment.getToken(
        { cardno, expire, holdername, securitycode, tokennumber: TOKEN_NO },
        resolve
      )
    })

  return { onGetToken }
}
